import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=98ffd5bc&"
import script from "./EventDetail.vue?vue&type=script&lang=ts&"
export * from "./EventDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports